import {quizActions, useQuiz} from "../../providers/QuizProvider.tsx";

interface YesNoQuestionProps {
    name: string;
    label: string;
    required?: boolean;
}

const YesNoQuestion = ({name, label, required = false}: YesNoQuestionProps) => {
    const {state, dispatch} = useQuiz();
    const value = state.formData[name];

    const handleChange = (answer: boolean) => {
        dispatch(quizActions.updateFormData({[name]: answer}));
    };

    return (
        <div className="mb-6">
            <label className="block text-sm font-medium mb-3">
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <div className="flex gap-4">
                <button
                    type="button"
                    onClick={() => handleChange(true)}
                    className={`flex-1 py-3 px-6 rounded-md font-medium transition-all ${
                        value === true
                            ? 'bg-green-600 text-white shadow-md'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                >
                    Yes
                </button>
                <button
                    type="button"
                    onClick={() => handleChange(false)}
                    className={`flex-1 py-3 px-6 rounded-md font-medium transition-all ${
                        value === false
                            ? 'bg-red-600 text-white shadow-md'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                >
                    No
                </button>
            </div>
        </div>
    );
};

export default YesNoQuestion;